import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CUSTOM_FIELDS_ACTION_TYPE = createNamedActions('system/customFields', {
  SET_CUSTOM_FIELDS: 'SET_CUSTOM_FIELDS',
  MERGE_CUSTOM_FIELDS: 'MERGE_CUSTOM_FIELDS',
  ADD_CUSTOM_FIELD: 'ADD_CUSTOM_FIELD',
  UPDATE_CUSTOM_FIELD: 'UPDATE_CUSTOM_FIELD',
  DELETE_CUSTOM_FIELD: 'DELETE_CUSTOM_FIELD',
  UPSERT_CUSTOM_FIELD_OVERRIDE: 'UPSERT_CUSTOM_FIELD_OVERRIDE',
  DELETE_CUSTOM_FIELD_OVERRIDE: 'DELETE_CUSTOM_FIELD_OVERRIDE',
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  CLEAR_ERROR: 'CLEAR_ERROR',
  RESET: 'RESET',
});
